<template>
    <v-app-bar
        app
        clipped-right
        color="primary"
        dark
    >
        <app-bar-logo></app-bar-logo>

        <v-toolbar-title>{{ $store.get('tryout/title') }}</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            @click.stop="finish"
            text
            class="mr-6"
            :class="doneClass"
            :loading="$store.get('loader/loading', 'finishing')"
        >
            <v-icon left>mdi-check</v-icon>
            Selesai
        </v-btn>

        <div class="title mr-2 mr-sm-4">
            {{ timer }}
        </div>

        <v-dialog
            v-model="pauseDialog"
            max-width="400"
            v-if="!isPauseFeatureDisabled"
        >
            <template #activator="{ on }">
                <v-btn
                    v-on="on"
                    icon
                >
                    <v-icon>mdi-pause</v-icon>
                </v-btn>
            </template>

            <v-card>
                <v-card-title>Jeda tryout?</v-card-title>
                <v-card-subtitle>
                    Tryout akan dijeda sampai kamu memulainya lagi
                </v-card-subtitle>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        @click="pauseDialog = false"
                        text
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        @click="pause"
                        text
                        color="primary"
                        :loading="$store.get('loader/loading', 'pausing')"
                    >
                        Jeda
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-btn
            icon
            @click="toggleQuestionNavigator"
        >
            <v-icon>mdi-view-module</v-icon>
        </v-btn>
    </v-app-bar>
</template>

<script>
import { sync, get } from 'vuex-pathify'
import AppBarLogo from '@/components/AppBarLogo'
import finishButton from './finishButton'

export default {
    components: {
        AppBarLogo,
    },

    data() {
        return {
            pauseDialog: false,
        }
    },

    computed: {
        questionNavigator: sync('tryout/questionNavigator'),
        remaining_second: get('tryout/remaining_second'),
        isPauseFeatureDisabled: get(
            'enrollment/selected@is_pause_feature_disabled'
        ),
        timer() {
            var hours = Math.floor(this.remaining_second / 3600)
            var minutes = Math.floor(this.remaining_second / 60) % 60
            var seconds = this.remaining_second % 60

            return [hours, minutes, seconds]
                .map((v) => (v < 10 ? '0' + v : v))
                .filter((v, i) => v !== '00' || i > 0)
                .join(':')
        },

        doneClass: finishButton.doneClass,
    },

    methods: {
        finish: finishButton.finish,

        pause() {
            this.$api
                .put(
                    `work/${this.$store.get('tryout/history_hash')}/pause`,
                    {},
                    { loader: 'pausing' }
                )
                .then(() => {
                    this.$tracking.event.tryout.pause(
                        `${this.$store.get('tryout/title')} ${this.$store.get(
                            'enrollment/selected@title'
                        )}`
                    )
                    this.$router.replace({ name: 'dashboard' })
                })
        },

        toggleQuestionNavigator() {
            if (this.$vuetify.breakpoint.lgAndUp) {
                if (!this.questionNavigator) {
                    this.$tracking.event.tryout.showDesktopQuestionNavigator(
                        `${this.$store.get('tryout/title')} ${this.$store.get(
                            'enrollment/selected@title'
                        )}`
                    )
                } else {
                    this.$tracking.event.tryout.hideDesktopQuestionNavigator(
                        `${this.$store.get('tryout/title')} ${this.$store.get(
                            'enrollment/selected@title'
                        )}`
                    )
                }
            }

            this.questionNavigator = !this.questionNavigator
        },
    },
}
</script>
